import { fetchNoticeDatas, delNoticeDatas } from '@/services'
import { inquiryDetail } from '@/services/inqueryServices'
export default {
  namespaced: true,
  state: {
    project: {}
  },
  mutations: {
    setProject (state, project) {
      state.project = project
    }
  },
  actions: {
    setPid ({ commit }, pid) {
      commit('setPid', pid, { root: true })
    },
    async fetchNoticeDatas ({ commit }) {
      const chain = await fetchNoticeDatas()
        .onSuccess(payload => {})
        .config({
          tip: false
        })
      return chain
    },
    async delNoticeDatas ({ commit }) {
      const chain = await delNoticeDatas()
        .onSuccess(payload => {})
        .config({
          tip: false
        })
      return chain
    },
    async fetchInquiryDetail ({ commit }, params) {
      const chain = await inquiryDetail()
        .params(params)
        .config({
          tip: false
        })
      return chain
    }
  }
}
